<template>
    <div>
        <v-dialog v-model="showGlassbreak" persistent max-width="480">
            <v-card>
                <v-card-title class="headline">Are you sure you want to go back home?</v-card-title>
                <v-card-text>
                    Your changes will not be saved and you may be assigned a new treatment time if you sign in again.
                </v-card-text>
                <v-card-actions id="glasbreakButtons">
                    <v-btn text outlined color="primary" @click="backToLobby" class="elevation-3">Go back home</v-btn>
                    <v-btn dark raised color="primary" @click="$store.state.showGlassbreak = false" class="elevation-3">Stay here</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="showInstructions" max-width="480" @click:outside="$store.state.showInstructions = false">
            <v-card>
                <v-card-title class="headline">Instructions</v-card-title>
                <v-card-text style="font-size: 14px;" v-html="instructions">
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn dark raised color="primary" @click="$store.state.showInstructions = false">Got it</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import ContextualMixin from '../mixins/contextualMixin'
    export default {
        name: 'Modals',
        mixins: [ContextualMixin],
        computed: {
            instructions() {
                if (!this.currentModel) return null;
                let message = this.currentModel.settings.localizedContent['walkin_tooltip'];
                if (!message) return null;
                if (message.includes('{PHONE}') && this.currentModel.settings.clientPhone)
                    message = message.replace('{PHONE}',
                        `<a style="display: block; font-weight:700;" href="tel:${this.currentModel.settings.clientPhone}">${this.currentModel.settings.clientPhone}</a>`);
                return message;
            }
        }
    }
</script>